export const SUBMIT_FARE_ALERT = 'SUBMIT_FARE_ALERT';
export const FARE_ALERT_SUBMITTED = 'FARE_ALERT_SUBMITTED';
export const TOGGLE_FARE_ALERT = 'TOGGLE_FARE_ALERT';

export const submitFareAlert = (email, currency, alertUrl) => {
    return {
        type: SUBMIT_FARE_ALERT,
        email,
        currency,
        alertUrl
    }
};

export const fareAlertSubmitted = (payload) => {
    return {
        type: FARE_ALERT_SUBMITTED,
        payload
    }
};

export const toggleFareAlert = () => {
    return {
        type: TOGGLE_FARE_ALERT
    }
};



// WEBPACK FOOTER //
// ./src/actions/FareAlertActions.js